import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RemoveIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Remove",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M2.57 29.48c.32.32.75.51 1.24.51s.92-.2 1.24-.51L16.03 18.5l11 10.98c.32.32.75.51 1.24.51A1.752 1.752 0 0 0 29.51 27l-11-10.98 10.98-11c.28-.31.46-.72.46-1.17a1.741 1.741 0 0 0-2.92-1.28s-11 10.98-11 10.98l-11-10.98a1.741 1.741 0 1 0-2.47 2.45s10.98 11 10.98 11l-10.97 11c-.31.31-.51.75-.51 1.23s.19.92.51 1.23"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27.86 29c-.29 0-.58-.11-.81-.33L4.19 5.81a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l22.86 22.86a1.14 1.14 0 0 1-.81 1.95"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5 29c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62L27.05 4.19a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62L5.81 28.67c-.22.22-.52.33-.81.33"
      })]
    })
  }));
};
RemoveIcon.displayName = 'RemoveIcon';